import React from "react";

import {BillDiscount, BillDiscountLine, BillDiscountRestControllerApiFactory,} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Page, PageHeader, Panel} from "../../../../components/kit";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormDataGrid, {FormDataGridColumn,} from "../../../../components/form/form_inputs/form_data_grid";

export const BillDiscountEditPage = () => {
	const apiManager = useApiManager();
	
	const ctrl = apiManager.factory(BillDiscountRestControllerApiFactory);


	const form = useForm({
		fetcher: (id) => ctrl.getBillDiscount(id),
		updater: (bean) => ctrl.saveBillDiscount(bean),
		remover: (id) => ctrl.deleteOrDismissBillDiscount(id),
		factory: () => {
			return {
			} as BillDiscount;
		}
	} as UseFormProps<BillDiscount>);


	const columns: FormDataGridColumn<BillDiscountLine>[] = [
		{editable: true, key: "amount", name: "Importe", width: "30%"},
		{editable: true, key: "percentage", name: "Descuento % (0-100)", width: "30%"},
	];

	return (
		<Page maxWidth={960}>
			<PageHeader back="/app/admin/billing/discount"
						title={form.getId() ? (form.value("name") || "Descuento") : "Nuevo descuento"}
						subtitle="Descuento por volumen: cada tramo dice a partir de qué importe se aplica qué porcentaje."/>
			<FormContent form={form} withoutPaper>
				<Panel title="Descuento">
					<FormInput field={"name"} label={"Nombre"}/>
					<FormInput field={"description"} label={"Descripción"} rows={5}/>
				</Panel>

				{form.getId() && (
					<Panel title="Tramos" sx={{mt: 3}}>
						<FormDataGrid
							title={"Tramos del descuento"}
							columns={columns}
							field={"lines"}
							onRemove={(ids) => {
								return apiManager
								.execute(ctrl.removeLinesBillDiscount(form.getIdOrErr(), ids))
								.then(() => {
									apiManager.enqueueSnackbar("Eliminación realizada");
								});
							}}
							onAppend={() => apiManager.execute(ctrl.appendLineBillDiscount(form.getIdOrErr()))}
						/>
					</Panel>
				)}
			</FormContent>
		</Page>
	);
};
